<!-- UNIVAPLAT-2992: turn a user's OTP mode to static (fixed code + reason) -->
<div class="modal-dialog modal-dialog-centered admin-modal">
    <div class="modal-content">
        <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="modal-header">
                <h1 class="modal-title fs-5" data-testid="otp-static-modal-title">
                    <i class="bi bi-shield-lock me-1"></i>
                    Turn to static
                </h1>
            </div>
            <div class="modal-body">
                <p class="mb-3" *ngIf="userName">
                    User: <strong data-testid="otp-static-modal-user-name">{{ userName }}</strong>
                </p>

                <fieldset class="form-group mb-3">
                    <label class="form-label" for="otp-static-code">Code</label>
                    <input id="otp-static-code"
                           type="text"
                           class="form-control"
                           inputmode="numeric"
                           maxlength="4"
                           autocomplete="off"
                           formControlName="code"
                           data-testid="otp-static-modal-code"
                           [class.is-invalid]="form.controls.code.touched && form.controls.code.invalid">
                    <div class="invalid-feedback d-block"
                         *ngIf="form.controls.code.touched && form.controls.code.errors?.['required']"
                         data-testid="otp-static-modal-code-required-error">
                        A code is required.
                    </div>
                    <div class="invalid-feedback d-block"
                         *ngIf="form.controls.code.touched && !form.controls.code.errors?.['required'] && form.controls.code.errors?.['codeFormat']"
                         data-testid="otp-static-modal-code-format-error">
                        The code must be exactly 4 digits.
                    </div>
                    <div class="invalid-feedback d-block"
                         *ngIf="form.controls.code.touched && form.controls.code.errors?.['codeWeak']"
                         data-testid="otp-static-modal-code-weak-error">
                        The code cannot be a sequential run or all the same digit.
                    </div>
                    <div class="invalid-feedback d-block"
                         *ngIf="form.controls.code.touched && form.controls.code.errors?.['codeInForce']"
                         data-testid="otp-static-modal-code-in-force-error">
                        This is the code already in force for this user — choose a different one.
                    </div>
                </fieldset>

                <fieldset class="form-group">
                    <label class="form-label" for="otp-static-reason">Reason</label>
                    <textarea id="otp-static-reason"
                              class="form-control"
                              rows="3"
                              formControlName="reason"
                              data-testid="otp-static-modal-reason"
                              [class.is-invalid]="form.controls.reason.touched && form.controls.reason.invalid"></textarea>
                    <div class="invalid-feedback d-block"
                         *ngIf="form.controls.reason.touched && form.controls.reason.errors?.['required']"
                         data-testid="otp-static-modal-reason-required-error">
                        A reason is required.
                    </div>
                </fieldset>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success"
                        [disabled]="saving || loading"
                        data-testid="otp-static-modal-submit">
                    Turn to static
                </button>
                <button type="button" class="btn btn-outline-dark" (click)="modal.close(false)"
                        data-testid="otp-static-modal-close">Close</button>
            </div>
        </form>
    </div>
</div>
<spinner *ngIf="loading"></spinner>
